{
  "id": "toolDrawers",
  "name": "Tool Drawers",
  "builds": "upgrade",
  "category": "shopFurniture",
  "note": "A place for everything, right under the bench.",
  "skill": "shopFurniture",
  "duration": 30,
  "offeredBy": "bench",
  "fastener": "nails",
  "widthIn": 24,
  "heightIn": 24,
  "slots": [
    {
      "id": "carcass-0",
      "role": "carcass",
      "part": {
        "widthIn": 24,
        "lengthIn": 24,
        "thicknessQ": 3
      },
      "stock": {
        "type": "plywood",
        "sheetGrade": "shopFurniture",
        "thickness": "any"
      },
      "xIn": 12,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "front-0",
      "role": "front",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "length": [24, 36],
        "width": "any",
        "thickness": [1, 2]
      },
      "xIn": 12,
      "yIn": 8,
      "angleDeg": 90,
      "zIn": 0.75
    },
    {
      "id": "front-1",
      "role": "front",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "length": [24, 36],
        "width": "any",
        "thickness": [1, 2]
      },
      "xIn": 12,
      "yIn": 16,
      "angleDeg": 90,
      "zIn": 0.75
    }
  ],
  "fasteners": [
    {
      "xIn": 6,
      "yIn": 8
    },
    {
      "xIn": 18,
      "yIn": 8
    },
    {
      "xIn": 6,
      "yIn": 16
    },
    {
      "xIn": 18,
      "yIn": 16
    }
  ]
}
